import React from 'react'

const SelectInput = React.forwardRef((props, ref) => (
  <label className='registration-label'>
    {props.label}
    <select className='registration-control' {...props} ref={ref}>
      { props.options.map((o, i) => <option key={i} value={o[0]}>{o[1]}</option>) }
    </select>
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default SelectInput
